<template>
  <div class="tax-inquiry-pay-now-settings" id="taxInquiryPayNowSettings">
    <div class="tax-inquiry-toggle-caption">Pay Now settings (payment entry)</div>
    <div class="d-flex align-center">
      <BinaryToggle
        class="mr-3"
        id="taxInquiryPayNowHalfToggle"
        aria-label="Pay Now: Full or Half"
        compact
        off-label="Full"
        on-label="Half"
        :value="halfOrPostmark.half"
        @input="isOn => onChangeHalfOrPostmark(isOn, 'half')" />
      <BinaryToggle
        id="taxInquiryPayNowPostmarkToggle"
        aria-label="Pay Now: Normal or Postmark OK"
        compact
        off-label="Normal"
        on-label="Postmark OK"
        :value="halfOrPostmark.postmark"
        @input="isOn => onChangeHalfOrPostmark(isOn, 'postmark')" />
    </div>
    <div class="tax-inquiry-toggle-hint">
      Used for the next payment opened with Pay Now (Alt + P)
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import BinaryToggle from '../../../common/base/BinaryToggle.vue';
import '../../../../assets/style.css';

// Full | Half and Normal | Postmark OK for the payment Pay Now opens. They write the same store
// flags as the Payments toolbar switches (paymentButtons.vue), so both screens show one mode.
export default {
  name: 'PayNowSettings',
  components: { BinaryToggle },
  computed: {
    ...mapState({
      halfOrPostmark: (state) => state.tax.taxPayment.halfOrPostmark,
    }),
  },
  methods: {
    ...mapMutations('tax/taxPayment', ['setHalfOrPostmark']),
    // `whichOne` is 'half' or 'postmark': set the persistent mode and the open payment's copy
    // together, as paymentButtons.onChangeHalfOrPostmark does.
    onChangeHalfOrPostmark(isOn, whichOne) {
      this.setHalfOrPostmark({ res: isOn, whichOne });
      this.setHalfOrPostmark({
        res: isOn,
        whichOne: whichOne === 'half' ? 'dialogHalf' : 'dialogPostmark',
      });
    },
  },
};
</script>
